/* eslint-disable */
import React from 'react';

export type AttackerTargetIconRender = () => React.ReactNode;

export const ATTACKER_TARGET_ICONS: AttackerTargetIconRender[] = [
  // 公事包
  () => (
    <svg
      width="63"
      height="57"
      viewBox="0 0 63 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.5 55.5V7.5C43.5 5.9087 42.8679 4.38258 41.7426 3.25736C40.6174 2.13214 39.0913 1.5 37.5 1.5H25.5C23.9087 1.5 22.3826 2.13214 21.2574 3.25736C20.1321 4.38258 19.5 5.9087 19.5 7.5V55.5M7.5 13.5H55.5C58.8137 13.5 61.5 16.1863 61.5 19.5V49.5C61.5 52.8137 58.8137 55.5 55.5 55.5H7.5C4.18629 55.5 1.5 52.8137 1.5 49.5V19.5C1.5 16.1863 4.18629 13.5 7.5 13.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 雲端
  () => (
    <svg
      width="70"
      height="51"
      viewBox="0 0 70 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.5179 19.5H48.7379C47.6155 15.153 45.2963 11.208 42.0439 8.11319C38.7914 5.01841 34.7361 2.89797 30.3387 1.99283C25.9413 1.08768 21.3782 1.43412 17.1679 2.99278C12.9575 4.55143 9.26883 7.2598 6.52087 10.8101C3.7729 14.3605 2.07588 18.6104 1.62263 23.0771C1.16938 27.5437 1.97808 32.0479 3.95684 36.0779C5.93559 40.1079 9.00506 43.502 12.8165 45.8747C16.6279 48.2473 21.0283 49.5033 25.5179 49.5H52.5179C56.4962 49.5 60.3115 47.9196 63.1245 45.1066C65.9376 42.2936 67.5179 38.4782 67.5179 34.5C67.5179 30.5218 65.9376 26.7064 63.1245 23.8934C60.3115 21.0804 56.4962 19.5 52.5179 19.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 帳本
  () => (
    <svg
      width="51"
      height="63"
      viewBox="0 0 51 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 54C1.5 52.0109 2.29018 50.1032 3.6967 48.6967C5.10322 47.2902 7.01088 46.5 9 46.5H49.5M1.5 54C1.5 55.9891 2.29018 57.8968 3.6967 59.3033C5.10322 60.7098 7.01088 61.5 9 61.5H49.5V1.5H9C7.01088 1.5 5.10322 2.29018 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9V54Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 靶心
  () => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.5 31.5C61.5 48.0685 48.0685 61.5 31.5 61.5M61.5 31.5C61.5 14.9315 48.0685 1.5 31.5 1.5M61.5 31.5H49.5M31.5 61.5C14.9315 61.5 1.5 48.0685 1.5 31.5M31.5 61.5V49.5M1.5 31.5C1.5 14.9315 14.9315 1.5 31.5 1.5M1.5 31.5H13.5M31.5 1.5V13.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 金錢
  () => (
    <svg
      width="39"
      height="69"
      viewBox="0 0 39 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 1.5V67.5M34.5 13.5H12C9.21523 13.5 6.54451 14.6062 4.57538 16.5754C2.60625 18.5445 1.5 21.2152 1.5 24C1.5 26.7848 2.60625 29.4555 4.57538 31.4246C6.54451 33.3938 9.21523 34.5 12 34.5H27C29.7848 34.5 32.4555 35.6062 34.4246 37.5754C36.3938 39.5445 37.5 42.2152 37.5 45C37.5 47.7848 36.3938 50.4555 34.4246 52.4246C32.4555 54.3938 29.7848 55.5 27 55.5H1.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const SHARED_ACCOUNT_ICONS: AttackerTargetIconRender[] = [
  // 卡片
  () => (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.1667 1.5H7.08333C3.99974 1.5 1.5 3.99974 1.5 7.08333V46.1667C1.5 49.2503 3.99974 51.75 7.08333 51.75H46.1667C49.2503 51.75 51.75 49.2503 51.75 46.1667V7.08333C51.75 3.99974 49.2503 1.5 46.1667 1.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0417 12.6667H12.6667V37.7917H21.0417V12.6667Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5833 12.6667H32.2083V26.625H40.5833V12.6667Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 雲端
  () => (
    <svg
      width="70"
      height="51"
      viewBox="0 0 70 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.5179 19.5H48.7379C47.6155 15.153 45.2963 11.208 42.0439 8.11319C38.7914 5.01841 34.7361 2.89797 30.3387 1.99283C25.9413 1.08768 21.3782 1.43412 17.1679 2.99278C12.9575 4.55143 9.26883 7.2598 6.52087 10.8101C3.7729 14.3605 2.07588 18.6104 1.62263 23.0771C1.16938 27.5437 1.97808 32.0479 3.95684 36.0779C5.93559 40.1079 9.00506 43.502 12.8165 45.8747C16.6279 48.2473 21.0283 49.5033 25.5179 49.5H52.5179C56.4962 49.5 60.3115 47.9196 63.1245 45.1066C65.9376 42.2936 67.5179 38.4782 67.5179 34.5C67.5179 30.5218 65.9376 26.7064 63.1245 23.8934C60.3115 21.0804 56.4962 19.5 52.5179 19.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 用戶
  () => (
    <svg
      width="64"
      height="53"
      viewBox="0 0 64 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.5 51V45.5C45.5 42.5826 44.3411 39.7847 42.2782 37.7218C40.2153 35.6589 37.4174 34.5 34.5 34.5H12.5C9.58262 34.5 6.78473 35.6589 4.72183 37.7218C2.65893 39.7847 1.5 42.5826 1.5 45.5V51M62 51V45.5C61.9982 43.0628 61.187 40.6951 59.6938 38.7689C58.2005 36.8426 56.1099 35.4668 53.75 34.8575M42.75 1.8575C45.1161 2.46333 47.2134 3.83943 48.711 5.76885C50.2087 7.69828 51.0216 10.0713 51.0216 12.5138C51.0216 14.9562 50.2087 17.3292 48.711 19.2586C47.2134 21.1881 45.1161 22.5642 42.75 23.17M34.5 12.5C34.5 18.5751 29.5751 23.5 23.5 23.5C17.4249 23.5 12.5 18.5751 12.5 12.5C12.5 6.42487 17.4249 1.5 23.5 1.5C29.5751 1.5 34.5 6.42487 34.5 12.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 雲端上傳
  () => (
    <svg
      width="62"
      height="51"
      viewBox="0 0 62 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1809 36.1601L30.8476 25.4934L41.5142 36.1601M30.8476 25.4934V49.4935M53.2209 42.5334C55.8218 41.1155 57.8764 38.8718 59.0605 36.1564C60.2447 33.4411 60.4908 30.4087 59.7601 27.538C59.0294 24.6672 57.3635 22.1215 55.0253 20.3026C52.6872 18.4838 49.8099 17.4954 46.8476 17.4934H43.4876C42.6804 14.3714 41.176 11.473 39.0874 9.0161C36.9988 6.55918 34.3805 4.60771 31.4291 3.3084C28.4778 2.00909 25.2704 1.39574 22.0479 1.51447C18.8254 1.6332 15.6717 2.48091 12.824 3.99389C9.97631 5.50686 7.50865 7.64572 5.60654 10.2497C3.70444 12.8536 2.41739 15.8549 1.84216 19.0278C1.26694 22.2008 1.4185 25.4629 2.28545 28.5688C3.15241 31.6748 4.7122 34.5438 6.84755 36.9601"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 鎖
  () => (
    <svg
      width="48"
      height="54"
      viewBox="0 0 48 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 24.0126V14.0126C11.4969 10.9127 12.6457 7.92226 14.7234 5.62176C16.8012 3.32126 19.6596 1.87485 22.7438 1.56331C25.8279 1.25178 28.9179 2.09735 31.4137 3.93587C33.9095 5.7744 35.6331 8.47471 36.25 11.5126M6.5 24.0126H41.5C44.2614 24.0126 46.5 26.2512 46.5 29.0126V46.5126C46.5 49.274 44.2614 51.5126 41.5 51.5126H6.5C3.73858 51.5126 1.5 49.274 1.5 46.5126V29.0126C1.5 26.2512 3.73858 24.0126 6.5 24.0126Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 金錢
  () => (
    <svg
      width="39"
      height="69"
      viewBox="0 0 39 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 1.5V67.5M34.5 13.5H12C9.21523 13.5 6.54451 14.6062 4.57538 16.5754C2.60625 18.5445 1.5 21.2152 1.5 24C1.5 26.7848 2.60625 29.4555 4.57538 31.4246C6.54451 33.3938 9.21523 34.5 12 34.5H27C29.7848 34.5 32.4555 35.6062 34.4246 37.5754C36.3938 39.5445 37.5 42.2152 37.5 45C37.5 47.7848 36.3938 50.4555 34.4246 52.4246C32.4555 54.3938 29.7848 55.5 27 55.5H1.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const ICON_SETS = {
  'attacker-target': ATTACKER_TARGET_ICONS,
  'shared-account': SHARED_ACCOUNT_ICONS,
} as const;

export type AttackerTargetGridVariant = keyof typeof ICON_SETS;
